import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { getCorrelatedAdsIds, searchItems } from '@sbt-web/network/client';
import { AdItem, CorrelatedTrackingInfo } from '@sbt-web/network/types';
import { urnTransformer } from '@sbt-web/utils';
export const loadData = async function (urn: string, userIdPromise: Promise<string>): Promise<[Array<AdItem>, CorrelatedTrackingInfo | undefined] | null> {
  const adItems: Array<AdItem> = [];
  const userId = await userIdPromise;
  const listId = urn.split(':list:')[1];
  const listIds: Array<string> = [];
  // get the ids of the related ads

  try {
    const {
      body: {
        ids,
        trackingInfo
      }
    } = await getCorrelatedAdsIds(process.env.NEXT_PUBLIC_POROS_BASE_URL, listId, userId, 'ad-view-detail');
    ids.forEach(urn => {
      const urnDetail = urnTransformer(urn);
      if (urnDetail?.contentId) {
        listIds.push(urnDetail?.contentId);
      }
    });

    // get the related ads from anubis
    if (!listIds.length) {
      return null;
    }
    const {
      body: {
        ads: anubiItems
      }
    } = await searchItems(process.env.NEXT_PUBLIC_HADES_BASE_URL, {
      list_ids: listIds.join(',')
    });

    //Return ordered element:
    if (anubiItems.length > 0) {
      listIds?.forEach(listId => {
        const itemIndex = anubiItems.findIndex(ad => {
          return ad.urn.includes(`:list:${listId}`);
        });
        if (itemIndex !== -1) {
          adItems.push(anubiItems[itemIndex]);
          anubiItems.splice(itemIndex, 1);
        }
      });
    }
    return [adItems, trackingInfo];
  } catch {
    // nothing to do
  }
  return null;
};
export function useData(urn, apiBase, userId, useWorker) {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [item, setItem] = useState(t0);
  const [isLoading, setIsLoading] = useState(true);
  const [trackingInfo, setTrackingInfo] = useState();
  const [success, setSuccess] = useState();
  let t1;
  if ($[1] !== urn || $[2] !== userId) {
    t1 = () => {
      let removed = false;
      (async () => {
        const data = await loadData(urn, userId);
        if (!removed) {
          if (data !== null) {
            const [adItems, trackingInfo_0] = data;
            setItem(adItems);
            setTrackingInfo(trackingInfo_0);
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setIsLoading(false);
        }
      })();
      return () => {
        removed = true;
      };
    };
    $[1] = urn;
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== apiBase || $[5] !== urn || $[6] !== useWorker || $[7] !== userId) {
    t2 = [urn, apiBase, useWorker, userId];
    $[4] = apiBase;
    $[5] = urn;
    $[6] = useWorker;
    $[7] = userId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] !== isLoading || $[10] !== item || $[11] !== success || $[12] !== trackingInfo) {
    t3 = [item, trackingInfo, success, isLoading];
    $[9] = isLoading;
    $[10] = item;
    $[11] = success;
    $[12] = trackingInfo;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}